import { Routes, Route } from "react-router-dom";
import { ReferrerTracker } from "./components/util/ReferrerTracker";
import Layout from "@/components/layout/layout";
import Home from "@/pages/Home";
import Demo from "@/pages/Demo";
import Blog from "@/pages/Blog";
import BlogPost from '@/pages/BlogPost';
import PayerDirectory from '@/pages/PayerDirectory';

const App = () => {
  return (
    <>
      <ReferrerTracker />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/resources/payer-directory" element={<PayerDirectory />} />
        </Routes>
      </Layout>
    </>
  );
};

export default App;
